export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8541.fd3690bc.jpg";